import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=9930747a&scoped=true&"
import script from "./OverviewPage.vue?vue&type=script&lang=js&"
export * from "./OverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=9930747a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9930747a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDataTable,VImg,VTextField,VTextarea})
